import React, { FC } from 'react';
import { ButtonGroup } from '@blink/components';
import { RadioChangeEvent } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

import { useLendStyle } from './Lend.style';

export const LendGroupList = [
    {
        text: 'Lend',
        value: '/',
    },
    {
        text: 'Borrow',
        value: '/borrow',
    },
];

export const LeverageScreenButtonGroup: FC = () => {
    const classes = useLendStyle();
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const handleChange = (e: RadioChangeEvent) => {
        if (pathname !== e.target.value) {
            navigate(e.target.value);
        }
    };

    return (
        <div className={classes.root}>
            <ButtonGroup
                className={classes.group}
                items={LendGroupList}
                value={pathname}
                handleChange={handleChange}
            />
        </div>
    );
};
